/**
 * @author Rahul Nainala
 * @description 
 */
import './CSS/eLog.css';
import axios from 'axios';
import moment from 'moment';
// import * as XLSX from 'xlsx';
import { Header } from './Widgets';
import FormType from './formtype.js';
import { connect } from 'react-redux';
import { LOGBOOK } from '../../../commons/api';
// import Highlighter from 'react-highlight-words';
import React, { useEffect, useState } from 'react';
import { DoubleLeftOutlined} from '@ant-design/icons';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table.js';
import { Button, Input, message, Popconfirm, Space, Tabs } from 'antd';
import { updateBatchStatus, getConfigByElogName, getList, _saveELogEdit } from './eLogCalls';
import { StyledHomepage } from '../../../commons/styles/layout.js';
import dayjs from 'dayjs';

const newLocal = true;
const { TabPane } = Tabs;

const ELogbookView = (props) => {
  // const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState('1');
  const [location, setLocation] = useState('');
  // const [data, setData] = useState([]);
  // const [date, setDate] = useState('');
  // const [json, setJson] = useState({});
  // const [userName, setUserName] = useState('');
  const [header, setHeader] = useState([]);
  const [recordType, setRecordType] = useState('user');
  const [Remarks, setRemarks] = useState('');
  const [editData, setEditData] = useState('');
  const [formType, setFormType] = useState('');
  const [elog, setElog] = useState({});
  const [elogName, setElogName] = useState({});
  const [headerValue, setHeaderValue] = useState({});
  const [form, setForm] = useState({});
  const [saveStatus, setSaveStatus] = useState(false);
  const [logList, setLogList] = useState('');
  const [process, setProcess] = useState({});
  const [adhocTable, setAdhocTable] = useState([]);
  const [status, setStatus] = useState('');
  const [dataSource, setDataSource] = useState([]);
  // const [logId, setLogId] = useState('');
  const [action, setAction] = useState('');
  // const [searchText, setSearchText] = useState({});
  // const [editObj, setEditObj] = useState({});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const path = props && props.params && props.params['*'];
    const splitPath = path && path !== undefined && path.split('/');
    let elogName = splitPath && splitPath[splitPath.length - 1];
    _getAdhocDataSource(elogName);
  }, []);

  const _getAdhocDataSource = async (elogName) => {
    let dataSource = await getList(elogName);
    let config = await getConfigByElogName(elogName);
    _initialDataSetup(config, props.userProfile);
    setUserProfile(props.userProfile);
    setEditData(config);
    setDataSource(dataSource);
    setElogName(elogName);
  };

  const _initialDataSetup = async (json, userProfile) => {
    if (json && !json.Id) {
      // setJson(json);
      setForm(json?.JSON?.form || {});
      setHeaderValue({
        CurrentDate: moment().format('YYYY-MM-DD'),
        CurrentTime: moment().format('HH:mm:ss'),
        userName: userProfile.user ? userProfile.user.FirstName : '',
        location: json?.Location || location,
        ...(json?.JSON?.headerValue || {})
      });
      setLocation(json?.Location || '');
      setRemarks(json?.Remarks || '');
      setProcess(json?.Process || '');
      setFormType(json?.FormType || '');
      setAdhocTable(json?.TableName || '');
      setElog(json);
      setLogList('');
      setHeader(json?.JSON?.header || []);
      // setDate(moment());    
      // setUserName(json?.userName || '');    
      setRecordType(json?.recordType || '');
      setStatus('');

    } else if (json && json.Id) {
      // setJson(json);
      setForm(json?.JSON?.form || {});
      setHeaderValue({
        CurrentDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        userName: userProfile.user ? userProfile.user.FirstName : '',
        location: json?.Location || location,
        ...(json?.JSON?.headerValue || {})
      });
      setLocation(json?.headerValue?.Location || '');
      // setDate(moment());    
      // setUserName(json?.userName || '');    
      setHeader(json?.JSON?.header || []);
      setRecordType(json?.recordType || '');
      setRemarks(json?.Remarks || '');
      setProcess(json?.Process || '');
      setFormType(json?.FormType || '');
      setElog(json);
      setAdhocTable(json?.TableName || '');
      setLogList(json?.Id || '');
      // setLogId(json?.logId || '');    
      setStatus(json?.status || '');
    }
  };

  const checkAllRows = (formType, form) => {
    let row = false;
    if (formType === 'EquipmentBatch') {
      form &&
        Object.keys(form).map((tabs) => {
          let mainHeaderValue = Object.keys(form.mainHeaderValue).length;

          tabs !== 'mainHeader' &&
            tabs !== 'mainHeaderValue' &&
            form &&
            form[tabs] &&
            Object.keys(form[tabs]).map((dynamicTabs) => {
              let HeaderData =
                form[tabs] &&
                form[tabs][dynamicTabs] &&
                form[tabs][dynamicTabs].headerValue &&
                dynamicTabs !== 'defaultData';

              if (mainHeaderValue !== 0 && HeaderData !== false && HeaderData !== undefined) {
                if (dynamicTabs !== 'defaultData') {
                  let HeaderValue =
                    form[tabs] &&
                    form[tabs][dynamicTabs] &&
                    Object.keys(form[tabs][dynamicTabs].headerValue).length;
                  if (HeaderValue !== 0) {
                    form[tabs] &&
                      form[tabs][dynamicTabs] &&
                      form[tabs][dynamicTabs].header &&
                      Object.keys(form[tabs][dynamicTabs].header).map((header) => {
                        if (header && header.required && header.required === true) {
                          if (!form[tabs][dynamicTabs].headerValue[header]) {
                            row = true;
                          }
                        }
                        return {};
                      });
                    let active =
                      form[tabs] &&
                      form[tabs][dynamicTabs] &&
                      form[tabs][dynamicTabs].headerValue &&
                      form[tabs][dynamicTabs].headerValue.EquipmentActiveStatus;
                    if (
                      active === 'Yes' &&
                      form[tabs][dynamicTabs]['form'].datasource !== undefined &&
                      form[tabs][dynamicTabs]['form'].datasource
                    ) {
                      let dataSource =
                        form[tabs] &&
                        form[tabs][dynamicTabs] &&
                        form[tabs][dynamicTabs]['form'] &&
                        Object.keys(form[tabs][dynamicTabs]['form'].datasource).length;
                      if (dataSource !== 0) {
                        let batchColumns =
                          form[tabs] &&
                          form[tabs][dynamicTabs] &&
                          form[tabs][dynamicTabs]['form'] &&
                          form[tabs][dynamicTabs]['form'].columns &&
                          Array.isArray(form[tabs][dynamicTabs]['form'].columns) &&
                          form[tabs][dynamicTabs]['form'].columns.map((dataColumns) => {
                            return dataColumns.key;
                          });

                        Object.keys(form[tabs][dynamicTabs]['form'].datasource).map((keys) => {
                          if (batchColumns && batchColumns.length > 0) {
                            batchColumns &&
                              Array.isArray(batchColumns) &&
                              batchColumns.map((batchkeys) => {
                                if (
                                  !form[tabs][dynamicTabs]['form'].datasource[keys][batchkeys] &&
                                  batchkeys !== 'Defloccular'
                                ) {
                                  row = true;
                                }
                                return {};
                              });
                          }
                          return {};
                        });
                      } else {
                        if (dataSource === 0) {
                          row = true;
                        }
                      }
                    }
                  } else {
                    if (HeaderValue === 0) {
                      row = true;
                    }
                  }
                }
              } else {
                if (
                  mainHeaderValue === 0 ||
                  (HeaderData === undefined && dynamicTabs !== 'defaultData')
                ) {
                  row = true;
                }
              }
              return {};
            });
          return {};
        });
    } else if (formType === 'FormWithSubModelsTable' || formType === 'FormWithSubModels') {
      form &&
        Object.keys(form).map((tabs) => {
          form &&
            form[tabs] &&
            Object.keys(form[tabs]).map((sections) => {
              let mainHeaderValue = Object.keys(form.mainHeaderValue).length;
              let batchColumns =
                form['mainHeader'] &&
                form['mainHeader'] &&
                Array.isArray(form['mainHeader']) &&
                form['mainHeader'].map((dataColumns) => {
                  return dataColumns.key;
                });
              if (mainHeaderValue !== 0) {
                batchColumns &&
                  Array.isArray(batchColumns) &&
                  batchColumns.map((batchkeys) => {
                    if (
                      !form['mainHeaderValue'][batchkeys] &&
                      form['mainHeaderValue'][batchkeys] !== 0
                    ) {
                      row = true;
                    }
                    return {};
                  });
                if (
                  form[tabs] &&
                  form[tabs][sections] &&
                  form[tabs][sections] &&
                  Object.keys(form[tabs][sections])
                ) {
                  if (sections !== 'defaultData') {
                    let formColumnsArray =
                      form[tabs] &&
                        form[tabs][sections] &&
                        form[tabs][sections]['form'] &&
                        form[tabs][sections]['form'].columns
                        ? form[tabs][sections]['form'].columns
                        : [];
                    let formColumnsObject =
                      form[tabs] &&
                      form[tabs][sections] &&
                      form[tabs][sections]['form'] &&
                      Array.isArray(formColumnsArray) &&
                      formColumnsArray.map((dataColumns) => {
                        return dataColumns.key;
                      });
                    if (form[tabs] && form[tabs][sections] && form[tabs][sections]['form']) {
                      formColumnsObject &&
                        Array.isArray(formColumnsObject) &&
                        formColumnsObject.map((batchkeys) => {
                          if (!form[tabs][sections].form.datasource[batchkeys]) {
                            row = true;
                          }
                          return {};
                        });
                    }
                    if (
                      form[tabs] &&
                      form[tabs][sections] &&
                      form[tabs][sections].table &&
                      form[tabs][sections].table
                    ) {
                      let batchNo =
                        form[tabs] &&
                        form[tabs][sections] &&
                        form[tabs][sections].table &&
                        form[tabs][sections].table.datasource;
                      let tableObject =
                        form[tabs] &&
                        form[tabs][sections] &&
                        form[tabs][sections].table &&
                        form[tabs][sections].table.columns;
                      let tableColumns =
                        form[tabs] &&
                        form[tabs][sections] &&
                        form[tabs][sections].table &&
                        Array.isArray(form[tabs][sections].table.columns) &&
                        tableObject &&
                        Array.isArray(tableObject) &&
                        tableObject.map((dataColumns) => {
                          return dataColumns.key;
                        });
                      tableColumns &&
                        Array.isArray(tableColumns) &&
                        tableColumns.map((batchkeys) => {
                          if (form[tabs][sections].table.validation === 'atleastOne') {
                            Object.keys(batchNo).map(() => {
                              if (batchNo[0].editable && batchNo[0].editable === true) {
                                row = true;
                              } else {
                                if (!batchNo[0][batchkeys]) {
                                  row = true;
                                }
                              }
                              return {};
                            });
                          } else {
                            Object.keys(batchNo).map((keys) => {
                              if (batchNo[keys].editable && batchNo[keys].editable === true) {
                                row = true;
                              } else {
                                if (!batchNo[keys][batchkeys]) {
                                  row = true;
                                }
                              }
                              return {};
                            });
                          }
                          return {};
                        });
                    }
                  }
                }
              } else {
                if (mainHeaderValue === 0) {
                  row = true;
                }
              }
              return {};
            });
          return {};
        });
    } else if (formType === 'GasLogForm' || formType === 'tableView') {
      form &&
        Object.keys(form).map((sections) => {
          let dataSource =
            form[sections].datasource &&
            Object.keys(form[sections].datasource).length &&
            sections !== 'table';
          if (dataSource !== 0 && sections !== 'table') {
            let batchColumns =
              form[sections] &&
              form[sections].columns &&
              Array.isArray(form[sections].columns) &&
              form[sections].columns.map((dataColumns) => {
                if (
                  form[sections].datasource.SampleType &&
                  form[sections].datasource.SampleType === 'Production'
                ) {
                  if (!dataColumns.show && dataColumns.required === true) {
                    return dataColumns.key;
                  }
                } else {
                  if (dataColumns.required === true) {
                    return dataColumns.key;
                  }
                }
                return {};
              });
            if (
              form[sections] &&
              form[sections].datasource &&
              Object.keys(form[sections].datasource) &&
              Object.keys(form[sections].datasource).length > 0
            ) {
              Object.keys(form[sections].datasource).map(() => {
                batchColumns &&
                  Array.isArray(batchColumns) &&
                  batchColumns.map((batchkeys) => {
                    if (!form[sections].datasource[batchkeys] && batchkeys !== undefined) {
                      row = true;
                    }
                    return {};
                  });
                return {};
              });
            }
          }
          if (sections === 'table') {
            let tableColumns = form[sections].columns;
            let batchColumns =
              form[sections] &&
              tableColumns &&
              Array.isArray(tableColumns) &&
              tableColumns.map((dataColumns) => {
                if (dataColumns.required === true) {
                  return dataColumns.key;
                }
                return {};
              });
            batchColumns &&
              Array.isArray(batchColumns) &&
              batchColumns.map((tableColumns) => {
                if (form[sections].validation === 'atleastOne') {
                  Object.keys(form[sections].datasource).map(() => {
                    if (
                      form[sections].datasource[0].editable &&
                      form[sections].datasource[0].editable === true
                    ) {
                      row = true;
                    } else {
                      if (!form[sections].datasource[0][tableColumns]) {
                        row = true;
                      }
                    }
                    return {};
                  });
                } else {
                  Object.keys(form[sections].datasource).map((key) => {
                    if (
                      form[sections].datasource[key].editable &&
                      form[sections].datasource[key].editable === true
                    ) {
                      row = true;
                    } else {
                      if (!form[sections].datasource[key][tableColumns]) {
                        row = true;
                      }
                    }
                    return {};
                  });
                }
                return {};
              });
          } else {
            if (dataSource === 0) {
              row = true;
            }
          }
          return {};
        });
    } else if (formType === 'FormWithFormSubSectionFormTable' || formType === 'FormTable') {
      form &&
        Object.keys(form).map((tabs) => {
          let mainHeaderValue =
            form && form.mainHeaderValue && Object.keys(form.mainHeaderValue).length;
          let batchColumns =
            form['mainHeader'] &&
            form['mainHeader'] &&
            Array.isArray(form['mainHeader']) &&
            form['mainHeader'].map((dataColumns) => {
              if (dataColumns.required === true) {
                return dataColumns.key;
              }
              return {};
            });
          if (mainHeaderValue !== 0) {
            batchColumns &&
              Array.isArray(batchColumns) &&
              batchColumns.map((batchkeys) => {
                // if (
                //   !form["mainHeaderValue"][batchkeys] && form["mainHeaderValue"][batchkeys] === 0
                //&& form["mainHeaderValue"][batchkeys] === "" &&
                //   batchkeys !== "NoOfChangeovers" || form["mainHeaderValue"][batchkeys] === undefined
                // ) {
                if (
                  (batchkeys !== 'NoOfChangeovers' && !form['mainHeaderValue'][batchkeys]) ||
                  (form['mainHeaderValue'][batchkeys] === 0 &&
                    form['mainHeaderValue'][batchkeys] === '' &&
                    form['mainHeaderValue'][batchkeys] === undefined)
                ) {
                  row =true;
                }
                return {};
              });

            tabs !== 'mainHeader' &&
              tabs !== 'mainHeaderValue' &&
              tabs !== 'model' &&
              form &&
              form[tabs] &&
              Object.keys(form[tabs]).map((sections) => {
                if (sections !== 'defaultData') {
                  let formDataSource = {};
                  let formDataSourcelength = {};
                  if (
                    form &&
                    form[tabs] &&
                    form[tabs][sections] &&
                    form[tabs][sections]['form'] &&
                    form[tabs][sections]['form'].datasource
                  ) {
                    formDataSource =
                      form &&
                      form[tabs] &&
                      form[tabs][sections] &&
                      form[tabs][sections]['form'] &&
                      form[tabs][sections]['form'].datasource;

                    formDataSourcelength =
                      form &&
                      form[tabs] &&
                      form[tabs][sections] &&
                      form[tabs][sections]['form'].datasource &&
                      Object.keys(form[tabs][sections]['form'].datasource).length;
                  } else {
                    formDataSource =
                      form &&
                      form[tabs] &&
                      form[tabs][sections] &&
                      form[tabs][sections] &&
                      form[tabs][sections].datasource;

                    formDataSourcelength =
                      form &&
                      form[tabs] &&
                      form[tabs][sections] &&
                      form[tabs][sections].datasource &&
                      Object.keys(form[tabs][sections].datasource).length;
                  }
                  // Object.keys(form[tabs][sections]["form"].datasource).length
                  if (formDataSourcelength !== 0) {
                    let columnsArray =
                      form[tabs] &&
                      form[tabs][sections] &&
                      form[tabs][sections]['form'] &&
                      form[tabs][sections]['form'].columns;

                    let formColumns =
                      form[tabs] &&
                      form[tabs][sections] &&
                      Array.isArray(columnsArray) &&
                      columnsArray.map((dataColumns) => {
                        if (!dataColumns.show && dataColumns.required === true) {
                          return dataColumns.key;
                        }
                        return {};
                      });

                    formColumns &&
                      Array.isArray(formColumns) &&
                      formColumns.map((batchkeys) => {
                        if (batchkeys !== undefined) {
                          if (!form[tabs][sections]['form'].datasource[batchkeys]) {
                            row = true;
                          }
                        }
                        return {};
                      });

                    let subsection =
                      form[tabs] && form[tabs][sections] && form[tabs][sections].subsection;

                    subsection &&
                      Object.keys(subsection).map((subSectionKeys) => {
                        let subsectionData = form[tabs][sections].subsection[subSectionKeys];
                        if (
                          subsectionData &&
                          subsectionData['form'] &&
                          subsectionData['form'].columns
                        ) {
                          let subColumns =
                            subsectionData &&
                            subsectionData['form'] &&
                            subsectionData['form'].columns;
                          let subsectionColumns =
                            Array.isArray(subColumns) &&
                            subColumns.map((columns) => {
                              if (
                                formDataSource &&
                                formDataSource['Typology'] &&
                                formDataSource['Typology'] === 'SINGLECHARGE'
                              ) {
                                if (!columns.show && columns.required === true) {
                                  return columns.key;
                                }
                              } else {
                                if (columns.required === true) {
                                  return columns.key;
                                }
                              }
                              return {};
                            });

                          let subsectionDataSourceLength =
                            subsectionData &&
                            subsectionData['form'] &&
                            subsectionData['form'].datasource &&
                            Object.keys(subsectionData['form'].datasource).length;
                          if (subsectionDataSourceLength !== 0) {
                            subsectionColumns &&
                              Array.isArray(subsectionColumns) &&
                              subsectionColumns.map((batchkeys) => {
                                if (batchkeys !== undefined) {
                                  if (
                                    !subsectionData['form'].datasource[batchkeys] &&
                                    subsectionData['form'].datasource[batchkeys] === null
                                  ) {
                                    row = true;
                                  }
                                }
                                return {};
                              });

                            let dynamicsubsection =
                              form[tabs] &&
                              form[tabs][sections] &&
                              form[tabs][sections].subsection &&
                              form[tabs][sections].subsection[subSectionKeys] &&
                              form[tabs][sections].subsection[subSectionKeys]['form'] &&
                              form[tabs][sections].subsection[subSectionKeys]['form'][
                              'dynamicSubForm'
                              ];
                            dynamicsubsection &&
                              Object.keys(dynamicsubsection).map((dynamicsubsectionkey) => {
                                let dynamicformdata =
                                  form[tabs][sections].subsection[subSectionKeys]['form'][
                                  'dynamicSubForm'
                                  ][dynamicsubsectionkey];

                                if (
                                  form[tabs][sections].subsection[subSectionKeys]['form']
                                    .datasource[dynamicsubsectionkey]
                                ) {
                                  if (
                                    dynamicformdata &&
                                    dynamicformdata['form'] &&
                                    dynamicformdata['form'].columns
                                  ) {
                                    let subColumns =
                                      dynamicformdata &&
                                      dynamicformdata['form'] &&
                                      dynamicformdata['form'].columns;

                                    let subsectionColumns =
                                      Array.isArray(subColumns) &&
                                      subColumns.map((columns) => {
                                        if (
                                          columns.required === true &&
                                          columns.disabled !== true
                                        ) {
                                          return columns.key;
                                        }
                                        return {};
                                      });
                                    let dynamicformDataSource =
                                      dynamicformdata &&
                                      dynamicformdata['form'] &&
                                      dynamicformdata['form'].datasource &&
                                      Object.keys(dynamicformdata['form'].datasource).length;
                                    if (dynamicformDataSource !== 0) {
                                      subsectionColumns &&
                                        Array.isArray(subsectionColumns) &&
                                        subsectionColumns.map((batchkeys) => {
                                          if (batchkeys !== undefined) {
                                            dynamicformdata['form'].datasource &&
                                              Object.keys(dynamicformdata['form'].datasource).map(
                                                (dataKey) => {
                                                  if (
                                                    !dynamicformdata['form'].datasource[dataKey][
                                                    batchkeys
                                                    ]
                                                  ) {
                                                    row = true;
                                                  }

                                                  return {};
                                                }
                                              );
                                          }
                                          return {};
                                        });
                                    } else {
                                      if (dynamicformDataSource < 0) {
                                        row = true;
                                      }
                                    }
                                  }
                                }
                                return {};
                              });
                          } else {
                            if (subsectionDataSourceLength === 0) {
                              row = true;
                            }
                          }
                        }

                        if (
                          subsectionData &&
                          subsectionData['table'] &&
                          subsectionData['table'].columns
                        ) {
                          let subColumns =
                            subsectionData &&
                            subsectionData['table'] &&
                            subsectionData['table'].columns;

                          let subsectionColumns =
                            Array.isArray(subColumns) &&
                            subColumns.map((columns) => {
                              if (
                                formDataSource &&
                                formDataSource['Typology'] &&
                                formDataSource['Typology'] === 'SINGLECHARGE'
                              ) {
                                if (!columns.show && columns.required === true) {
                                  return columns.key;
                                }
                              } else {
                                if (columns.required === true) {
                                  return columns.key;
                                }
                              }
                              return {};
                            });
                          let subsectionDataSourceLength =
                            subsectionData &&
                            subsectionData['table'] &&
                            subsectionData['table'].datasource &&
                            subsectionData['table'].datasource.length;

                          if (subsectionDataSourceLength !== 0) {
                            subsectionColumns &&
                              Array.isArray(subsectionColumns) &&
                              subsectionColumns.map((batchkeys) => {
                                if (batchkeys !== undefined) {
                                  subsectionData['table'].datasource.map(() => {
                                    //   if (!subsectionData["table"].datasource[index].editable) {
                                    //     if (
                                    //       !subsectionData["table"].datasource[index][batchkeys]
                                    //     ) {
                                    //       row = true;
                                    //     }
                                    //   }
                                    // })
                                    if (subsectionData['table'].validation === 'atleastOne') {
                                      Object.keys(subsectionData['table'].datasource).map(() => {
                                        if (
                                          subsectionData['table'].datasource[0].editable &&
                                          subsectionData['table'].datasource[0].editable === true
                                        ) {
                                          row = true;
                                        } else {
                                          if (!subsectionData['table'].datasource[0][batchkeys]) {
                                            row = true;
                                          }
                                        }
                                        return {};
                                      });
                                    } else {
                                      Object.keys(subsectionData['table'].datasource).map(
                                        (datakey) => {
                                          if (
                                            subsectionData['table'].datasource[datakey].editable &&
                                            subsectionData['table'].datasource[datakey].editable ===
                                            true
                                          ) {
                                            row = true;
                                          } else {
                                            if (
                                              !subsectionData['table'].datasource[datakey][
                                              batchkeys
                                              ]
                                            ) {
                                              row = true;
                                            }
                                          }
                                          return {};
                                        }
                                      );
                                    }
                                    return {};
                                  });
                                }
                                return {};
                              });
                            // if (batchkeys !== undefined) {
                            // if (subsectionData["table"].validation === "atleastOne") {
                            //   Object.keys( subsectionData["table"].datasource).map((datakey, index) => {
                            //     if (!subsectionData["table"].datasource[0].editable === true) {
                            //       row = true

                            //     } else {
                            //       if (!subsectionData["table"].datasource[0]) {
                            //         row = true
                            //       }
                            //     }
                            //   })
                            // }
                            // else {
                            //   Object.keys( subsectionData["table"].datasource).map((datakey, index) => {
                            //     if (!subsectionData["table"].datasource[index].editable === true) {
                            //       row = true

                            //     } else {
                            //       if (!subsectionData["table"].datasource[index]) {
                            //         row = true
                            //       }
                            //     }
                            //   })
                            // }
                            // }

                            let dynamicsubsection =
                              form[tabs] &&
                              form[tabs][sections] &&
                              form[tabs][sections].subsection &&
                              form[tabs][sections].subsection[subSectionKeys] &&
                              form[tabs][sections].subsection[subSectionKeys]['form'] &&
                              form[tabs][sections].subsection[subSectionKeys]['form'][
                              'dynamicSubForm'
                              ];

                            dynamicsubsection &&
                              Object.keys(dynamicsubsection).map((dynamicsubsectionkey) => {
                                let dynamicformdata =
                                  form[tabs][sections].subsection[subSectionKeys]['form'][
                                  'dynamicSubForm'
                                  ][dynamicsubsectionkey];

                                if (
                                  form[tabs][sections].subsection[subSectionKeys]['form']
                                    .datasource[dynamicsubsectionkey]
                                ) {
                                  if (
                                    dynamicformdata &&
                                    dynamicformdata['form'] &&
                                    dynamicformdata['form'].columns
                                  ) {
                                    let subColumns =
                                      dynamicformdata &&
                                      dynamicformdata['form'] &&
                                      dynamicformdata['form'].columns;

                                    let subsectionColumns =
                                      Array.isArray(subColumns) &&
                                      subColumns.map((columns) => {
                                        if (
                                          columns.required === true &&
                                          columns.disabled !== true
                                        ) {
                                          return columns.key;
                                        }
                                        return {};
                                      });
                                    let dynamicformDataSource =
                                      dynamicformdata &&
                                      dynamicformdata['form'] &&
                                      dynamicformdata['form'].datasource &&
                                      Object.keys(dynamicformdata['form'].datasource).length;
                                    if (dynamicformDataSource !== 0) {
                                      subsectionColumns &&
                                        Array.isArray(subsectionColumns) &&
                                        subsectionColumns.map((batchkeys) => {
                                          if (batchkeys !== undefined) {
                                            dynamicformdata['form'].datasource &&
                                              Object.keys(dynamicformdata['form'].datasource).map(
                                                (dataKey) => {
                                                  if (
                                                    !dynamicformdata['form'].datasource[dataKey][
                                                    batchkeys
                                                    ]
                                                  ) {
                                                    row = true;
                                                  }
                                                  return {};
                                                }
                                              );
                                          }
                                          return {};
                                        });
                                    } else {
                                      if (dynamicformDataSource === 0) {
                                        row = true;

                                      }
                                    }
                                  }
                                }
                                return {};
                              });
                          } else {
                            if (subsectionDataSourceLength === 0) {
                              row = true;
                            }
                          }
                        }
                        return {};
                      });

                    if (sections === 'samples') {
                      Object.keys(form[tabs][sections]['form'].datasource).map((key) => {
                        if (form[tabs][sections]['form'].datasource[key] === null) {
                          row = true;
                        }

                        return {};
                      });
                    }
                  } else {
                    if (formDataSourcelength === 0) {
                      row = true;
                    }
                  }
                }
                return {};
              });
          } else {
            if (mainHeaderValue === 0) {
              row = true;
            }
          }
          return {};
        });
    }
    return row;
  };



//   const saveEditObject = async () => {
    
//     let siteId = localStorage.get('currentSite');
//     let { userProfile } = props;
//     let status = false;
//     let formData = {};
//     if (form) {
//       status = checkAllRows(formType, form);
//     }
//     if (form && form['form']) {
//       formData = {
//         ...form,
//         form: {
//           ...form['form'],
//           datasource: {
//             ...form['form']['datasource'],
//             Date: dayjs(form['form']['datasource']['Date']).utc().format('YYYY-MM-DD HH:mm:ss')
//           }
//         }
//       };
//     } else {
//       formData = {
//         ...form,
//         mainHeaderValue: {
//           ...form['mainHeaderValue'],
//           Date:
//             form &&
//             form['mainHeaderValue'] &&
//             form['mainHeaderValue']['Date'] &&
//             moment(form['mainHeaderValue']['Date']).utc().format('YYYY-MM-DD HH:mm:ss')
//         }
//       };
//     }

// const validateRequiredFields = form => {
//   let errors = [];
//   if(form.mainHeader){
//     form.mainHeader.forEach(field => {
//       // if(field.required && !form.mainHeaderValue[field.key]){
//       //   errors.push(`${field.displayName} is required.`);
//       // }
//     });
//   }
//   if(form.form && form.form.columns){
//     form.form.columns.forEach(field => {
//       if(field.required && !form.form.dataSource[field.key]){
//         errors.push(`${field.displayName} is required.`);
//       }
//     });
//   }
//   return errors;
// };

// const validationErrors = validateRequiredFields(formData);

// if(validationErrors.length > 0){
//   message.error(validationErrors.join(' '));
// }
// if(formData && !status===true){
//   if(formData){
//     delete formData.batch;
//      // Prepare payload for saving
//     let payload = {
//         logId: elog.logId,
//         formType,
//         JSON: {
//             form: { ...formData },
//             header,
//             headerValue
//         },
//         userId: userProfile && userProfile.user ? userProfile.user.Id : '',
//         roleId: userProfile.belongsTo.sites[siteId]
//             ? userProfile.belongsTo.sites[siteId].role.Id
//             : '',
//         adhocTable,
//         Remarks,
//         process
//     };
//     if (logList) {
//         payload.Id = logList;
//     }
//     // Save the data
//     try {
//         let updateResponse = await _saveELogEdit(payload);
//         let logId = updateResponse && updateResponse[0] && updateResponse[0].Id;
//         setSaveStatus(true);
//         setLogList(updateResponse);
//         message.success('You have saved Elog book no.' + logId);
//     } catch (error) {
//         message.error('Error saving Elog book.');
//     }
//   }
// }
  
// };
const saveEditObject = async () => {
    let siteId = localStorage.get('currentSite');
    let { userProfile } = props;
    let status = false;
    let formData = {};
 
    if (form) {
        status = checkAllRows(formType, form);
    }

    if (form && form['form']) {
        formData = {
            ...form,
            form: {
                ...form['form'],
                datasource: {
                    ...form['form']['datasource'],
                    Date: dayjs(form['form']['datasource']['Date']).utc().format('YYYY-MM-DD HH:mm:ss')
                }
            }
        };
    } else {
        formData = {
            ...form,
            mainHeaderValue: {
                ...form['mainHeaderValue'],
                Date: form && form['mainHeaderValue'] && form['mainHeaderValue']['Date']
                    ? moment(form['mainHeaderValue']['Date']).utc().format('YYYY-MM-DD HH:mm:ss')
                    : ''
            }
        };
    }

    const validateRequiredFields = (form) => {
        let errors = [];
        if (form.mainHeader) {
            form.mainHeader.forEach(field => {
                if (field.required && !form.mainHeaderValue[field.key]) {
                    errors.push(`${field.displayName} is required.`);
                }
            });
        }
        if (form.form && form.form.columns) {
            form.form.columns.forEach(field => {
                if (field.required && !form.form.datasource[field.key]) {
                    errors.push(`${field.displayName} is required.`);
                }
            });
        }
        return errors;
    };

    const validationErrors = validateRequiredFields(formData);

   
    if (validationErrors.length > 0) {
        message.error(validationErrors.join(' '));
        return;
    }


    if (formData && !status) {
        if (formData) {
            delete formData.batch; 

            let payload = {
                logId: elog.logId,
                formType,
                JSON: {
                    form: { ...formData },
                    header,
                    headerValue
                },
                userId: userProfile && userProfile.user ? userProfile.user.Id : '',
                roleId: userProfile.belongsTo.sites[siteId]
                    ? userProfile.belongsTo.sites[siteId].role.Id
                    : '',
                adhocTable,
                Remarks,
                process
            };

            if (logList) {
                payload.Id = logList;
            }

            try {
                let updateResponse = await _saveELogEdit(payload);
                let logId = updateResponse && updateResponse[0] && updateResponse[0].Id;
                setSaveStatus(true);
                setLogList(updateResponse);
                message.success('You have saved Elog book no. ' + logId);
            } catch (error) {
                message.error('Error saving Elog book.');
            }
        }
    }
};

  const _submitStatusAPI = async (payload) => {
    let logId = logList && logList[0] && logList[0].Id ? logList[0].Id : '';
    let statusResponse = await updateBatchStatus(payload, elogName);
    if (statusResponse && statusResponse.message) {
      setActiveKey('2');
      message.success('You have Submitted Elog book no.' + logId);
      if (form && form['dataSource'] && form['dataSource']['Type'] === 'Observation') {
        form &&
          form['columns'] &&
          Array.isArray(form['columns']) &&
          form['columns'].map((item) => {
            if (item.key === 'SubEquipment') {
              // item.table = []
              if (form && form['dataSource']) {
                form['dataSource'][item.key] = '';
              }
            }
            return {};
          });
        let form = {
          ...form,
          dynamicSubForm: {}
        };
      } else {
        setStatus('Completed');
      }
      setForm(form);
    } else {
      message.error('Error Occured');
    }
  };

  const SubmitLogbook = async () => {

    let siteId = localStorage.get('currentSite');
    let fieldValidation = false;
    if (form) {
      fieldValidation = await checkAllRows(formType, form);
    }
    let payload = {};
    payload = {
      status: 'submitted',
      Id: logList && logList[0] ? logList[0].Id : "",
      SiteId: siteId,
      // elogbookName: elogbookName
    };
    if (!fieldValidation) {
      _submitStatusAPI(payload);
    } else {
      message.warn('Mandatory Checks failed');
    }
  };

  const onChangeRemarks = (e) => {
    setRemarks(e.target.value);
  };

  const setValue = (e) => {
    let headerValue = {
      ...headerValue,
      [e.key]: e.value
    };
    setHeaderValue(headerValue);
  };

  // const saveSubSectionData = (form) => {setForm(form)};

  const downTimeData = (form) => { setForm(form); }; 


  const checkDeviceExistsOrNot = (dataExitsObject) => {
    let form = {
      ...form,
      ...(dataExitsObject &&
        dataExitsObject[0] &&
        dataExitsObject[0].JSON &&
        dataExitsObject[0].JSON.form
        ? dataExitsObject[0].JSON.form
        : {})
    };
    setForm(form);
  };

  // const setMainSaveId = (Id) => { setId(Id) };

  const getRecord = async (record) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${LOGBOOK.GetLogBookById}?SiteId=${siteId}&Id=${record.Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    try {
      return axios(Object).then((response) => {
        return response.data;
      });
    } catch (e) {
      return {};
    }
  };

  const handleOpenChange = async (newOpen) => {
    if (form) {
      await checkAllRows(formType, form);
    }
    if (saveStatus === true && logList) {
      setOpen(newOpen);
    } else {
      message.error('Please Save Before Submit');
      setOpen(false);
    }
  };

  const SubmitConfirm = () => {
    setOpen(false);
    SubmitLogbook('Submit');
  };

  const cancel = () => {
    setOpen(false);
    message.error('Click on cancel.');
  };

  let { translationCache } = props;

  let columns = [
    {
      title: 'Id',
      key: 'Id',
      dataIndex: 'Id'
    },
    {
      title: 'LogBookId',
      key: 'LogBookId',
      dataIndex: 'LogBookId'
    },
    {
      title: 'Location',
      key: 'Location',
      dataIndex: 'Location'
    },
    {
      title: 'Process',
      key: 'Process',
      dataIndex: 'Process'
    },
    {
      title: 'CreatedDate',
      key: 'CreatedDate',
      dataIndex: 'CreatedDate',
      render: (text) => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
    },
    {
      title: 'Status',
      key: 'Status',
      dataIndex: 'Status',
      render(text, record) {
        return {
          children: (
            <div>
              <Space style={{ color: record.Status === 'submitted' ? 'green' : 'red' }}>
                {text}
              </Space>
            </div>
          )
        };
      }
    }
  ];
  let permissionsArray = [];
  userProfile &&
    userProfile['belongsTo'] &&
    userProfile['belongsTo']['sites'] &&
    userProfile['belongsTo']['sites'][localStorage.get('currentSite')] &&
    userProfile['belongsTo']['sites'][localStorage.get('currentSite')]['role'] &&
    userProfile['belongsTo']['sites'][localStorage.get('currentSite')]['role']['Permission']
      .filter((item) => item.resource === 'elog_book')
      .map((name) => permissionsArray.push(name.action));


  return (
    <StyledHomepage>
      <Button type="dashed" style={{ marginBottom: '20px' }} onClick={() => props.navigate(-1)}>
        <DoubleLeftOutlined />
        Go Back
      </Button>
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        {process !== 'Field Data Measurement' && activeKey !== '2' ? (
          <Button
            type=""
            //className="saveButton"
            style={{ marginTop: '10px', float: 'right', marginRight: '20px' }}
            onClick={() => {
              setActiveKey('2');
              setStatus('Inprogress');
              // setEditObj({});
              setForm(form);
              setAction('new');
            }}
          >
            {translationCache && translationCache['Add New']
              ? translationCache['Add New']
              : 'Add New'}
          </Button>
        ) : null}
      </div>
      <Tabs
        type="card"
        defaultActiveKey="1"
        activeKey={activeKey}
        onChange={async (activeKey) => {
          let action = '';
          if (activeKey === '2' && process === 'Field Data Measurement') {
            return {};
          } else {
            if (activeKey === '2') {
              _initialDataSetup(editData, props.userProfile);
              action = 'new';
            }
            if (activeKey === '1') {
              const path = props && props.params && props.params['*'];
              const splitPath = path && path !== undefined && path.split('/');
              let processName = splitPath && splitPath[splitPath.length - 1];
              _getAdhocDataSource(processName);
            }
            setActiveKey(activeKey);
            setAction(action);
          }
        }}
      >
        <TabPane
          tab={
            translationCache && translationCache['List'] && translationCache['List']
              ? translationCache['List']
              : 'List'
          }
          key="1"
        >
          <StyledTable size="small" style={{ width: '100%' }} dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
            columns={columns}
            onRow={(tableRowData) => {
              return {
                onClick: async () => {
                  let data = await getRecord(tableRowData);
                  let record = data && Array.isArray(data) && data[0] ? data[0] : {};
                  let form = {
                    ...(record && record.JSON && record.JSON.form && record.JSON.form
                      ? record.JSON.form
                      : {})
                  };
                  setActiveKey('2');
                  setStatus(tableRowData && tableRowData.Status && tableRowData.Status === 'submitted'
                    ? 'Completed'
                    : status);
                  setForm(form);
                  setHeaderValue(record && record.JSON && record.JSON.headerValue
                    ? record.JSON.headerValue
                    : '');
                  setAction('');
                  // setEditObj(record);
                  setLogList(record && record['Id'] ? record['Id'] : '');
                  setSaveStatus(false);
                  setRemarks(record && record.Remarks ? record.Remarks : '');
                }
              };
            }}>
          </StyledTable>
        </TabPane>

        <TabPane
          tab={
            translationCache && translationCache['Details'] && translationCache['Details']
              ? translationCache['Details']
              : 'Details'
          }
          key="2"
        >
          <div>
            <div style={{ 'width': '30%', 'margin': '20px 0px' }}>
              {header && Array.isArray(header) && header.length > 0 ? (
                <Header
                  header={header}
                  headerValue={headerValue}
                  recordType={recordType}
                  setValue={setValue}
                  status={status}
                />
              ) : null}
            </div>
            <FormType
              formType={formType}
              formObject={form}
              header={header}
              headerValue={headerValue}
              recordType={recordType}
              elog={elog}
              userProfile={props.userProfile}
              translationCache={props.translationCache}
              status={status}
              // getMainSaveId={setMainSaveId}
              setValue={setValue}
              downTimeData={downTimeData}
              action={action}
              checkDeviceExistsOrNot={checkDeviceExistsOrNot}
              currentTimeZone={props.currentTimeZone}
            />

            <div>
              <div
                style={{
                  ...(status === 'Completed'
                    ? {
                      opacity: newLocal ? 0.75 : 1,
                      pointerEvents: newLocal ? 'none' : 'initial',
                      margin: '20px 0px'
                    }
                    : { margin: '20px 0px' })
                }}
              >
                <div 
                //className="RemarksHeading"
                 style={{ color: 'white' }}>
                  {translationCache && translationCache['Remarks'] && translationCache['Remarks']
                    ? translationCache['Remarks']
                    : 'Remarks'}{' '}
                </div>
                <Input.TextArea
                  value={Remarks && Remarks !== null && Remarks !== 'null' ? Remarks : ''}
                  onChange={(e) => onChangeRemarks(e)}
                  autoSize={{ minRows: 2, maxRows: 6 }}
                  style={{ width: '100%' }}
                  maxLength={250}
                />
                <div style={{ color: 'white' }}>
                  {translationCache &&
                    translationCache['Characters left'] &&
                    translationCache['Characters left']
                    ? translationCache['Characters left']
                    : 'Characters left'}{' '}
                  :{' '}
                  <span style={{ color: 'white', fontWeight: 'bold' }}>
                    {Remarks && Remarks !== null && Remarks !== 'null'
                      ? 250 - Remarks.length
                      : 250}{' '}
                  </span>
                </div>
              </div>

              <div style={{ margin: '20px 0px' }}>
                <Button
                  //className="saveButton"
                  disabled={
                    !permissionsArray.includes('create') || !permissionsArray.includes('update')
                      ? true
                      : false
                  }
                  style={{
                    ...(status === 'Completed'
                      ? {
                        opacity: newLocal ? 0.75 : 1,
                        pointerEvents: newLocal ? 'none' : 'initial',
                        marginRight: '5px'
                      }
                      : { marginRight: '5px' })
                  }}
                  type=""
                  onClick={(e) => saveEditObject(e)}
                >
                  {translationCache && translationCache['Save'] && translationCache['Save']
                    ? translationCache['Save']
                    : 'Save'}
                </Button>
                <Popconfirm
                  placement="right"
                  title="Do you want to submit?"
                  open={open}
                  onOpenChange={(e) => handleOpenChange(e)}
                  onConfirm={(e) => SubmitConfirm(e)}
                  onCancel={(e) => cancel(e)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    style={{
                      color: 'white',
                      fontWeight: 'bold',
                      ...(status === 'Completed'
                        ? {
                          opacity: newLocal ? 0.75 : 1,
                          pointerEvents: newLocal ? 'none' : 'initial'
                        }
                        : {})
                    }}
                    type="danger"
                    disabled={!permissionsArray.includes('submit') ? true : false}
                  >
                    {' '}
                    {translationCache && translationCache['Submit']
                      ? translationCache['Submit']
                      : 'Submit'}
                  </Button>
                </Popconfirm>
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </StyledHomepage>
  );


};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.loggedInProfile,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(ELogbookView);